/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {
  Cart,
  CartData,
} from '@/models';

import {
  createDraftOrder,
  updateDraftOrder,
} from './backend';
import {
  DraftOrderItemInput,
} from './draftOrder';

export async function addCartItem(cart: Cart | null, variantId: string, quantity: any): Promise<CartData> {
  // TODO: Server-side request
  if (!cart) {
    return createDraftOrder({
      currency: 'TWD',
      items: [{
        variantId,
        quantity,
      }],
      fulfillments: [],
    });
  } else {
    // Make sure the given quantity is a number.
    const q = parseInt(quantity, 10);
    if (isNaN(q)) {
      throw new Error(`provided quantity is not a number: ${quantity}`);
    } else if (q < 0) {
      throw new Error(`provided quantity must not be negative: ${quantity}`);
    }

    let isNewItem = true;
    const inputItems = cart.items.map<DraftOrderItemInput>((item) => {
      if (item.variant.id === variantId) {
        isNewItem = false;
        return {
          id: item.id,
          variantId,
          quantity: item.quantity + q,
        };
      } else {
        return {
          id: item.id,
          variantId: item.variant.id,
          quantity: item.quantity,
        };
      }
    });

    if (isNewItem) {
      inputItems.push({
        variantId,
        quantity: q,
      });
    }

    return updateDraftOrder(cart.id, { items: inputItems });
  }
}
